import { Link } from "react-router-dom";

const highlights = [
  { icon: "ri-flashlight-line", title: "实时速递", desc: "热点事件第一时间推送" },
  { icon: "ri-layout-grid-line", title: "分类清晰", desc: "八大分类快速定位内容" },
  { icon: "ri-heart-3-line", title: "收藏分享", desc: "好内容随时收藏与分享" },
  { icon: "ri-shield-check-line", title: "理性吃瓜", desc: "倡导客观理性的讨论氛围" },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100 border-t border-background-200">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
        <div>
          <div className="inline-flex items-center gap-2 text-primary-600 text-sm font-semibold mb-3">
            <i className="ri-information-line" />
            关于吃瓜网站
          </div>
          <h4 className="text-2xl md:text-3xl font-extrabold text-foreground-950 leading-tight">
            捕捉娱乐圈的每一个
            <span className="text-primary-500">精彩瞬间</span>
          </h4>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            吃瓜网站是一个专注娱乐新闻与热点八卦的资讯分享平台，涵盖明星动态、影视评论、网红事件与热点话题。我们希望用简洁清晰的阅读体验，
            让你在忙碌之余也能轻松掌握娱乐圈的最新动向。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-5 h-11 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-colors"
            >
              了解更多
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-5 h-11 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-50 whitespace-nowrap cursor-pointer transition-colors"
            >
              联系我们
            </Link>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3 md:gap-4">
          {highlights.map((h) => (
            <div key={h.title} className="p-4 md:p-5 rounded-lg bg-background-50 border border-background-200">
              <span className="w-11 h-11 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center mb-3">
                <i className={`${h.icon} text-xl`} />
              </span>
              <p className="text-base font-bold text-foreground-900">{h.title}</p>
              <p className="mt-1 text-xs md:text-sm text-foreground-500">{h.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}